<template>
    <div class='topMenuNoBorder'>
        <div class="topMenuContain">
            <div id="leftLogo">
<!--                <img class="leftLogo" src="../assets/img/login/logoLeft.png" alt="">-->
<!--                <div class="sep"></div>-->
                <img class="titleLogo" src="../assets/img/login/title.png" alt="">
            </div>
            <ul class="menuUl">
                <li class="normal">
                    <a v-if="loginView" href="#nomalProblemsBXE">常见问题</a>
                    <span v-else @click="normalProblemsClick">常见问题</span>
                </li>
              <!--                <li @click="reportSearchClick" class="normal">保单查询</li>-->
               <li @click="investmentClick" class="normal">投资型保险查询</li>
                <!--<li class="iconLi" v-if="logined">-->
                    <!--<el-dropdown size="medium" placement="bottom-start" trigger="click" @command="logOutClick">-->
                    <!--<span class="el-dropdown-link">-->
                        <!--<img src="../assets/img/person.png" alt="">-->
                        <!--<img src="../assets/img/rightIcon.png" alt="">-->
                    <!--</span>-->
                        <!--<el-dropdown-menu slot="dropdown">-->
                            <!--<el-dropdown-item  command="a">退出登录</el-dropdown-item>-->
                        <!--</el-dropdown-menu>-->
                    <!--</el-dropdown>-->
                <!--</li>-->
            </ul>
        </div>
    </div>
</template>
<script>
    import ElPopover from "../../node_modules/element-ui/packages/popover/src/main";
    export default{
        props:{
            loginView:{
                type:Boolean,
                defalut:true,
            },
            logined:{
                type:Boolean,
                defalut:false,
            }
        },
        data(){
            return {
                currentIndex:'0',
            }
        },
        computed:{
//            logined:{
//                get:function(){
//                    return  sessionStorage.getItem('logined')=='0'?false:true;
//                },
//                set:function(val){
//                    this.logined=val;
//                }
//            },
//            currentIndex:{
//                get:function () {
//                    return sessionStorage.getItem('currentIndex');
//                },
//                set:function (val) {
//                    this.currentIndex=val
//                }
//            },
        },
        watch:{

        },
        mounted(){

        },
        components: {
            ElPopover
        },
        methods: {
            loginOut:function () {

                var data={
                };
                var _this=this;
                this.$http({
                    url: '/userCenter/userQuit',
                    method: 'post',
                    data:data,
                }).then(function (res) {
//                        console.log(res);
                    if(res.data.code=='200'){
                        sessionStorage.clear();
                        _this.$parent.changeLoginType();
                        _this.$router.replace('/login');
                    }
                }).catch(function (err) {
//                        console.log(err);
                })

            },
            //退出登录事件
            logOutClick:function () {
                var _this=this;
                this.$confirm('是否退出登录?', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    _this.loginOut();
                }).catch(() => {

                });
            },
            investmentClick:function () {
                var problemLogined=sessionStorage.getItem('logined');
                if(problemLogined&&problemLogined=='1'){
                    this.currentIndex='1';
                    sessionStorage.setItem('currentIndex',this.currentIndex);
                    this.$router.push('/investmentReportList')
                }else if(!problemLogined||problemLogined=='0'){
                    if(this.loginView){
                        this.$alert('登录后方可使用', '提示', {
                            confirmButtonText: '确定',
                            type:'warning',
                            callback: action => {
                            }
                        });
                    }
//                        this.$message('登录后方可使用');
                    else{
                        this.$router.replace('/login');
                    }
                }
            },
            reportSearchClick:function () {
                var problemLogined=sessionStorage.getItem('logined');
                if(problemLogined&&problemLogined=='1'){
                    this.currentIndex='2'
//                    this.logined=true;
                    sessionStorage.setItem('currentIndex',this.currentIndex);
                    sessionStorage.setItem('companyCode','');
                    this.$router.push('/reportSearch')
                }else if(!problemLogined||problemLogined=='0') {
                    if (this.loginView) {
                        this.$alert('登录后方可使用', '提示', {
//                            showClose:false,
                            confirmButtonText: '确定',
                            type:'warning',
                            callback: action => {
                            }
                        });
                    } else {
                        this.$router.replace('/login');
                    }
                }
            },
            normalProblemsClick:function () {
                var problemLogined=sessionStorage.getItem('logined');
                this.currentIndex='3'
                sessionStorage.setItem('currentIndex','3');
                this.$router.push('/problemsList')
            }
        }
    }
</script>

<style scoped>
    @import "../assets/css/components/topMenu.css";
</style>